if (!customElements.get('recently-viewed')) {
    customElements.define('recently-viewed', class RecentlyVieved extends HTMLElement {
        constructor() {
            super();
            this.viewed_products =JSON.parse(localStorage.getItem('ViewedProductsSNDCT'));
            this.url = this.dataset.url;
            if(localStorage.getItem('ViewedProductsSNDCT') ){
                this.updateProductList();
                this.renderBlock();

            }else{
                this.addProductList();
            }
        }
        renderBlock() {
            if(this.viewed_products){
                let productList = this.viewed_products.join(',')
                const url = window.location.href.includes('/collections/') ? '/products/raw-school-skirt-red' : this.url;

                // fetch(`${this.url}?view=recently-viewed&products=${productList}&end-products`)
                fetch(`${url}?view=recently-viewed&products=${productList}&end-products`)
                    .then((response) => {
                        return response.text();
                    })
                    .then((response_html) => {
                        const html = new DOMParser().parseFromString(response_html, 'text/html')
                        const fetchProductList = html.querySelector('[data-recently-viewed]');
                        const productList = this.querySelector('[data-recently-viewed]');
                        if(fetchProductList && productList){
                            productList.innerHTML = fetchProductList.innerHTML;
                            if(window.lazyLoadEnabled == "true"){
                                reloadLazyLoad();
                            }
                            this.querySelector('.catalog').classList.remove('hidden');                   
                        }              
                    }) .catch((e) => {
                    console.error(e);
                });
            }
        }
        updateProductList(){
            let viewed_products =JSON.parse(localStorage.getItem('ViewedProductsSNDCT'));
            if(viewed_products.includes(`${this.dataset.handle}`)){
                viewed_products.splice(viewed_products.indexOf(`${this.dataset.handle}`), 1);
            }
            viewed_products.unshift(`${this.dataset.handle}`)
            viewed_products = viewed_products.slice(0,12)
            localStorage.setItem('ViewedProductsSNDCT', JSON.stringify(viewed_products));

        }
        addProductList(){
            let viewed_products =[`${this.dataset.handle}`];
            localStorage.setItem('ViewedProductsSNDCT', JSON.stringify(viewed_products));
        }
    });
}
